import {GET_DIVISION} from 'shared/constants/ActionTypes';

const INIT_STATE = {
  detail: '',
};

export const getDivisiReducers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DIVISION:
      return {
        ...state,
        detail: action.payload.detail,
      };
    default:
      return state;
  }
};

export default getDivisiReducers;
